import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { useFormik } from 'formik';

import { PRIVATE } from 'router/constants/routes';

import { updateUserEmail } from 'store/user/actions';

import { accountTabs } from 'constants/account';

import { sendAnalyticEmailUpdate } from 'services/analytics';

import { useDispatch } from 'hooks';

import { isEmpty } from 'helpers/dataStructuresUtils';

import { Text, Button } from 'components/library';
import FormikInput from 'components/FormikInput';

import * as S from './styled';

import emailIcon from 'assets/img/icons/emailIcon.svg';

import { ForgotPasswordSchema } from './validationSchema';

const initialValues = { email: '' };

type FormValue = { email: string };

const ChangeEmail = () => {
  const [isLoading, setLoadingState] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const settingsTabUrl = `${PRIVATE.ACCOUNT_DEFAULT.path}/${accountTabs.Settings}`;

  const { errors, dirty, values, setFieldTouched, setFieldValue, handleSubmit, touched } = useFormik({
    initialValues,
    validationSchema: ForgotPasswordSchema,
    onSubmit: (payload: FormValue) => {
      setLoadingState(true);
      dispatch(
        updateUserEmail({
          email: payload.email,
          onSuccess: () => {
            sendAnalyticEmailUpdate();
            navigate(settingsTabUrl);
          },
          onError: () => {
            setLoadingState(false);
            navigate(settingsTabUrl);
          },
        })
      );
    },
  });

  return (
    <S.Container $paddingTop={88} $paddingX={16} $paddingBottom={32}>
      <Text center mb={20} type="h5">
        {t('change.email.title')}
      </Text>
      <form>
        <div>
          <FormikInput
            type="email"
            field="email"
            label="change.email.newEmail"
            setFieldTouched={setFieldTouched}
            initialValues={values}
            setFieldValue={setFieldValue}
            touched={touched}
            values={values}
            errors={errors}
            mb={44}
            leftIcon={emailIcon}
            dataLocator="emailInput"
            placeholder={t('change.email.newEmail')}
          />
        </div>
        <Button
          onClick={handleSubmit}
          isLoading={isLoading}
          backgroundColor="primary-default"
          disabled={!dirty || !isEmpty(errors)}
          mb={24}
          dataLocator="saveBtn"
        >
          {t('account.profile.button.save')}
        </Button>
      </form>
    </S.Container>
  );
};

export default ChangeEmail;
